export const transactionTypes = ['all', 'pending', 'funds', 'savings', 'rewards'] as const;
export type TransactionType = typeof transactionTypes[number];

export const tabs = [
    {
        value: 'pending',
        query: 'pending',
    },
    {
        value: 'all',
        query: 'all',
    },
    {
        value: 'completed',
        query: 'funds',
    },
    {
        value: 'vault',
        query: 'savings',
    },
    {
        value: 'rewards',
        query: 'rewards',
    },
];

export const transactionHistoryPageSize = 10;